import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';

// idb store name
const storeName = 'requisicoes';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configColetor');
const host = configLocal ? JSON.parse(configLocal).host : '';
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const baseURL = environment === 'production' ? `erp?url=${host}` : host;

export const requisicaoService = {
  getRequisicoes,
  getRequisicoesFromIndex,
  getRequisicoesKeysFromIndex,
  getRequisicao,
  getRequisicaoFromIndex,
  addRequisicao,
  addItemRequisicao,
  addItemBarraRequisicao,
  updateRequisicao,
  deleteRequisicao,
  deleteRequisicoes,
  deleteRequisicoesLocal,
  getNextIdItemRequisicao,
  sendRequisicaoAPI,
};

function getRequisicoes() {
  return getIndexedDBRequisicoes();
}

function getRequisicoesFromIndex(indexName, id) {
  return idbService.getAllFromIndex(storeName, indexName, id);
}

function getRequisicoesKeysFromIndex(indexName, id) {
  return idbService.getAllKeysFromIndex(storeName, indexName, id);
}

function getRequisicaoFromIndex(indexName, id) {
  return idbService.getFromIndex(storeName, indexName, id);
}

function sendRequisicaoAPI(requisicao) {
  return apiRequest.post(`${baseURL}/requisicao`, {
    opcoes: {
      acao: 'registro',
      finaliza_auto: true
    },
    dados: requisicao
  });
}

function getIndexedDBRequisicoes() {
  return idbService.getAll(storeName);
}

function getRequisicao(id) {
  return idbService.getById(storeName, id);
}

// async function removeInexistentes(requisicoesApi) {
//   if (requisicoesApi && requisicoesApi.length) {
//     const idsRequisicoesApi = requisicoesApi.map(prodApi => prodApi.id_requisicao);
//     const requisicoesLocal = await idbService.getAll('requisicoes');
//     const requisicoesInexistentes = requisicoesLocal.filter(prodLocal => !idsRequisicoesApi.includes(prodLocal.id_requisicao));
//     if (requisicoesInexistentes && requisicoesInexistentes.length) {
//       for (const requisicao of requisicoesInexistentes) {
//         await idbService.deleteFromStore('requisicoes', requisicao.id_requisicao);
//       }
//     }
//   } else {
//     return;
//   }
// }

async function addRequisicao(requisicao) {
  return idbService.addToStore(storeName, requisicao);
}

async function addItemRequisicao(idRequisicao, item) {
  const requisicao = await getRequisicao(idRequisicao);
  item.id_item = await getNextIdItemRequisicao(idRequisicao);
  requisicao.itens.push(item);
  await updateRequisicao(requisicao);

  return requisicao;
}

async function addItemBarraRequisicao(idRequisicao, idProduto, barra) {
  const requisicao = await getRequisicao(idRequisicao);
  const itemRequisicao = requisicao.itens.find(item => item.id_produto == idProduto);

  itemRequisicao.barras.push(barra);
  await updateRequisicao(requisicao);

  return requisicao;
}

async function updateRequisicao(requisicao) {
  if (requisicao.itens && requisicao.itens.length) {
    if (requisicao.id_producao && requisicao.itens.length) {
      requisicao.itens.forEach(item => sumQtdeRequisitadaItem(item));
      requisicao.qtde_realizada = requisicao.itens[0].barras.length;
    } else {
      requisicao.qtde_realizada = requisicao.itens.length;
    }
  }
  await idbService.updateItem(storeName, requisicao);
}

async function deleteRequisicaoLocal(idInterno) {
  try {
    await idbService.deleteFromStore(storeName, idInterno);
    return true;
  } catch (error) {
    return error;
  }
}

async function deleteRequisicao(idInterno) {
  try {
    const requisicao = await getRequisicao(idInterno);
    if (requisicao && requisicao.id_requisicao) {
      // await apiRequest.put(`${baseURL}/requisicao?Acao=exclui&id_requisicao=${requisicao.id_requisicao}`, {}, {
      await apiRequest.put(`${baseURL}/requisicao`, {
        opcoes: {
          acao: 'exclui',
          id_requisicao: requisicao.id_requisicao
        }
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      });
    }
    await idbService.deleteFromStore(storeName, idInterno);
    return true;
  } catch (error) {
    return error;
  }
}

async function deleteRequisicoes(requisicoes = []) {
  // const promises = [];

  // requisicoes.forEach(requisicao => promises.push(idbService.deleteFromStore(storeName, requisicao.id_interno)));
  // requisicoes.forEach(requisicao => promises.push(deleteRequisicao(requisicao.id_interno)));

  for (const requisicao of requisicoes) {
    await deleteRequisicao(requisicao.id_interno);
  }

  // O Promise.all deu problemas na Syclus API v1 por resolver as promises em pararelo
  // De alguma forma a Syclus API v1 trava, tendo que fechar e abrir novamente
  // Promise.all(promises)
  //   .then(() => true)
  //   .catch(err => err);
}

async function deleteRequisicoesLocal(requisicoes = []) {
  for (const requisicao of requisicoes) {
    await deleteRequisicaoLocal(requisicao.id_interno);
  }
}

async function getNextIdItemRequisicao(idRequisicao) {
  const requisicoes = await getRequisicao(idRequisicao);
  const lastItem = requisicoes.itens[requisicoes.itens.length - 1];
  if (lastItem) return lastItem.id_item + 1;
  else return 1;
}

function sumQtdeRequisitadaItem(item) {
  return item.qtde_requisitada = item.barras.length;
}